import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Application Components
import { LoginComponent } from './login/login.component';
import { ChangePassComponent } from './change-pass/change-pass.component';
import { ConfirmUserComponent } from './confirm-user/confirm-user.component';
import { ResetPassComponent } from './reset-pass/reset-pass.component';
import { SolicitarConfirmacionComponent } from './solicitar-confirmacion/solicitar-confirmacion.component';
import { RegistroComponent } from './registro/registro.component';
import { MigrationUserComponent } from './migration-user/migration-user.component';
import { LogoutComponent } from './logout/logout.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'change-pass',
        component: ChangePassComponent
      },
      {
        path: 'confirm-user',
        component: ConfirmUserComponent
      },
      {
        path: 'reset-pass',
        component: ResetPassComponent
      },
      {
        path: 'solicitar-confirmacion',
        component: SolicitarConfirmacionComponent
      },
      {
        path: 'registro',
        component: RegistroComponent
      },
      {
        path: 'migration-user',
        component: MigrationUserComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
